import styled from "styled-components/macro";

export const TypographyHeadlineSmallElement = styled.h2`
  margin: 0;
  font-weight: 400;
`;
